const WALLET_TYPES = {
  LEDGER: 'ledger',
  TREZOR: 'trezor',
  BITBOX2: 'bitbox02',
  KEEPKEY: 'keepkey',
  WALLET_CONNECT: 'walletConnect',
  KEYSTORE: 'keystore',
  MNEMONIC: 'mnemonic',
  WEB3_WALLET: 'web3Wallet',
  PRIV_KEY: 'privKey',
  COOL_WALLET: 'coolWallet',
  COOL_WALLET_S: 'coolWalletS',
  COOL_WALLET_PRO: 'coolWalletPro',
  WALLET_LINK: 'walletLink',
  MEW_WALLET: 'mewWallet'
};
export default WALLET_TYPES;
